webpackJsonp([108788251640254],{

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Completed Project'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The final code for the Quickstart can be checked out from GitHub using the link below:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        git clone git@github.com:lore/lore-quickstart-es5-v0.13.git\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        git clone git@github.com:lore/lore-quickstart-es6-v0.13.git\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        git clone git@github.com:lore/lore-quickstart-esnext-v0.13.git\n        ' })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Each step in the Quickstart contains the name of the branch with the completed code for that step. For example, to check out the code for Step 1 of the Authorization section, which has the branch name ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'authorization.1'
	      ),
	      ', you would run this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      git checkout authorization.1\n      ' }),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you\'re developing on Mac or Windows, you can also use the excellent (and official) ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://desktop.github.com/' },
	          'GitHub Desktop Client'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-misc-completed-project-js-a03d5b2de1bc2a887f37.js